import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/shared/services/language.service';

@Component({
  selector: 'atom-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  currentLanguage!: string;

  languages = [
    { code: 'es' },
    { code: 'en' }
  ];

  globeIconPath = '/assets/images/globo.png';

  constructor(private languageService: LanguageService) {}

  ngOnInit() {
    this.languageService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }

  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);

    // Recargar la página para aplicar el idioma y mostrar la data por defecto
    window.location.reload();
  }
}
